import { Link } from 'react-router-dom';
import type { Article } from '@/types';

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-100 rounded-lg overflow-hidden border border-background-300/30 hover:border-primary-500/30 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-2.5">
          <span className="px-2 py-0.5 bg-accent-500/15 text-accent-400 text-xs rounded font-medium">
            {article.category}
          </span>
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}分钟阅读
          </span>
          <span className="text-xs text-foreground-500">{article.publishDate}</span>
        </div>
        <h3 className="text-base font-medium text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-400 transition-colors">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-2 mt-3 flex-wrap">
          {article.tags.map((tag) => (
            <span key={tag} className="text-xs text-foreground-500 bg-background-200 px-2 py-0.5 rounded">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}